import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { getToasts, removeToast } from '$lib/stores/toastStore.svelte';

var root_2 = $.from_html(`<p class="text-xs opacity-80 mt-0.5 truncate"> </p>`);
var root_1 = $.from_html(`<div role="alert"><span class="shrink-0 font-bold text-sm mt-0.5"> </span> <div class="flex-1 min-w-0"><p class="text-sm font-medium"> </p> <!></div> <button class="shrink-0 opacity-70 hover:opacity-100 transition-opacity text-sm font-bold leading-none" aria-label="Dismiss">✕</button></div>`);
var root = $.from_html(`<div class="fixed bottom-4 right-4 z-50 flex flex-col gap-2 w-80 max-w-[calc(100vw-2rem)]" aria-live="polite" aria-atomic="false"></div>`);

export default function Toaster($$anchor, $$props) {
	$.push($$props, false);

	const typeStyles = {
		success: 'bg-green-600 text-white',
		error: 'bg-destructive text-white',
		warning: 'bg-yellow-500 text-white',
		info: 'bg-primary text-primary-foreground'
	};

	const typeIcons = { success: '✓', error: '✕', warning: '⚠', info: 'ℹ' };

	$.init();

	var div = root();

	$.each(div, 5, getToasts, (toast) => toast.id, ($$anchor, toast) => {
		var div_1 = root_1();
		var span = $.child(div_1);
		var text = $.child(span, true);

		$.reset(span);

		var div_2 = $.sibling(span, 2);
		var p = $.child(div_2);
		var text_1 = $.child(p, true);

		$.reset(p);

		var node = $.sibling(p, 2);

		{
			var consequent = ($$anchor) => {
				var p_1 = root_2();
				var text_2 = $.child(p_1, true);

				$.reset(p_1);
				$.template_effect(() => $.set_text(text_2, $.get(toast).description));
				$.append($$anchor, p_1);
			};

			$.if(node, ($$render) => {
				if ($.get(toast).description) $$render(consequent);
			});
		}

		$.reset(div_2);

		var button = $.sibling(div_2, 2);

		button.__click = () => removeToast($.get(toast).id);
		$.reset(div_1);

		$.template_effect(() => {
			$.set_class(div_1, 1, `flex items-start gap-3 rounded-lg px-4 py-3 shadow-lg ${typeStyles[$.get(toast).type] ?? typeStyles.info ?? ''}`);
			$.set_text(text, typeIcons[$.get(toast).type] ?? typeIcons.info);
			$.set_text(text_1, $.get(toast).message);
		});

		$.append($$anchor, div_1);
	});

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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